import Vue from 'vue'

const displayMenu = {
    state: {

        listleft: [],
        listtop: [],
        listAll: [],
        overlay: false,
        current: false,
        textOverlay: '',
        buildSpecificPage : [],

    },

    getters: {

        listleft: (state) => {
            return state.listleft
        },

        listtop: (state) => {
            return state.listtop
        },

        specificPage: (state) => (id) => {
            return state.buildSpecificPage.find(specific => specific.page === id)
        },

        specificPageByKey: (state) => (id) => {
            return state.buildSpecificPage.find(specific => specific[id.key] === id.value)
        },

        isoverlay: (state) => {
            return state.overlay
        },
        textOverlay: (state) => {
            return state.textOverlay
        },
        listAll: (state) => {
            return state.listAll
        },
        currentPage: (state) => {
            return state.current
        }
    },

    mutations: {

        textOverlay: function(state, value) {
            state.textOverlay = value
        },

        pushMenuLeft: function(state, liste) {
            state.listleft.push(liste)
        },

        pushMenuTop: function(state, liste) {
            state.listtop.push(liste)
        },

        pushAll: function(state, liste) {
            state.listAll.push(liste)
        },
        removeAllPages: function(state) {
            state.listAll = []
            state.listleft = []
            state.listtop = []
            state.current = false
            state.buildSpecificPage = []
        },
        getoverlay: function(state, is) {
            state.overlay = is
        },
        current: function(state, page) {
            state.current = page
        },

        changeParamPage: function(state, params) {
            if(!state.listAll.length) return;
            const specificPage = state.buildSpecificPage.find(specific => specific.page === params.page)
            // Pendant l'initialisation de session, la liste des routes peut être
            // reconstruite avant que l'instance de page correspondante soit créée.
            if(!specificPage) return

            if (params.key) {
                if(!specificPage[params.item] || typeof specificPage[params.item] !== 'object') {
                    Vue.set(specificPage, params.item, {})
                }
                Vue.set(specificPage[params.item], params.key, params.value)
            } else {
                Vue.set(specificPage, params.item, params.value)
            }

        },

        initPage: function(state, params) {
            let specific = state.listAll.find(specific => specific.props.page === params.page);
            // An embedded chat resource can target a module without a menu route.
            // Its authorised metadata is local to this new modalKey.
            if(!specific && params.metadata) specific = params.metadata
            if(!specific) return
            let spe = JSON.parse(JSON.stringify(specific));
            let build = {   idpage:spe.props.page, 
                            page : params.modalKey, 
                            name:spe.name, 
                            table : spe.table,
                            displayname:spe.displayname, 
                            props:spe.props, 
                            parentform :spe.parentform,
                            embedded : Boolean(params.embedded)}

            state.buildSpecificPage = state.buildSpecificPage.filter(specific => specific.page !== params.modalKey)
            state.buildSpecificPage.push(build);

        },

        removeSpecificPage: function(state, modalKey) {
            state.buildSpecificPage = state.buildSpecificPage.filter(specific => specific.page !== modalKey)
        },

    },

    actions: {

        pushMenuLeft: function({ commit }, liste) {
            commit('pushMenuLeft', liste)
        },

        pushMenuTop: function({ commit }, liste) {
            commit('pushMenuTop', liste)
        },

        pushAll: function({ commit }, liste) {
            commit('pushAll', liste)
        },
        removeAllPages: function({ commit }) {
            commit('removeAllPages')
        },
        getoverlay: function({ commit }, val) {
            commit('getoverlay', val)
        },
        changeParamPage: function({ commit }, params) {
            commit('changeParamPage', params)
        },
        textOverlay: function({ commit }, value) {
            commit('textOverlay', value)
        },
        current: function({ commit }, value) {
            commit('current', value)
        },
        initPage: function({ commit }, params) {
            commit('initPage', params)
        },
        removeSpecificPage: function({ commit }, modalKey) {
            commit('removeSpecificPage', modalKey)
        },
    }

}
export default displayMenu;
